import { Body, Checkbox, Flex } from '@hover/blueprint';
import React from 'react';

export type CheckListItem = {
  id: string;
  name: string;
  isChecked: boolean;
  dataTestId: string;
  label: string;
};

export type CheckListParams = {
  items: CheckListItem[];
  onSelectedIdsChanged: (selectedIds: string[]) => void;
  testId: string;
};

export const CheckList = ({
  items,
  onSelectedIdsChanged,
  testId,
}: CheckListParams) => {
  const onItemClicked = (index: number) => {
    const newSelection = [...items];
    newSelection[index].isChecked = !newSelection[index].isChecked;
    onSelectedIdsChanged(
      newSelection.filter(item => item.isChecked).map(item => item.id),
    );
  };

  return (
    <Flex data-testid={testId} direction="column" gap={400} width="100%">
      {items.map(({ name, isChecked, dataTestId, label }, index) => (
        <Flex
          aria-label={label}
          data-testid={dataTestId}
          direction="row"
          key={name}
          width="100%"
        >
          <Body>{name}</Body>
          <Checkbox
            isChecked={isChecked}
            marginLeft="auto"
            onChange={() => onItemClicked(index)}
          />
        </Flex>
      ))}
    </Flex>
  );
};
